import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import OldObjects from "../../components/OldObjects/OldObjects";

const OldObjectsPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar/>
                    <OldObjects/>
                </div>
            </div>
        </div>
    );
};

export default OldObjectsPage;
